<template>
  <div class="text-center">
    <v-menu
      v-if="show"
      light
      max-width="380"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          icon
          color="primary"
        >
          <v-icon v-text="icons.moreHorizontal" />
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="canRefund" @click="confirmRefund = true">
          <v-list-item-icon>
            <v-icon v-text="icons.refund" />
          </v-list-item-icon>
          <v-list-item-title v-text="__('refundAction')" />
        </v-list-item>
      </v-list>
    </v-menu>
    <h-refund
      v-if="canRefund"
      v-model="confirmRefund"
      :order="order"
    />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import NeedsPermission from '@/Mixins/NeedsPermission'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HRefund from './Refund'

  export default {
    mixins: [
      I18n,
      NeedsPermission,
      UsesIcons,
    ],

    components: {
      HRefund,
    },

    props: {
      order: {
        required: true,
        type: Object,
      },
    },

    data: () => ({
      confirmRefund: false,
    }),

    computed: {
      show () {
        return this.canRefund // || this.canWhatever || this.canWhatever
      },
      ...mapState('cashControl', [
        'turn',
      ]),
      ...mapGetters('cashControl', [
        'shouldCloseTurn',
      ]),
      canRefund () {
        return this.can('refundOrder')
          && !! this.turn
          && ! this.shouldCloseTurn
          && this.order.canBeRefunded
      },
    },
  }
</script>
